export const careStatusOptions = [
  { text: '待發送', value: '0' },
  { text: '已發送', value: '1' },
  { text: '待重試', value: '2' },
  { text: '取消發送', value: '3' },
  { text: '處理中', value: '4' },
  { text: '時間已過', value: '5' },
];

export function careStatusLabel(status) {
  const option = careStatusOptions.find(item => item.value === String(status));
  return option ? option.text : '未知';
}

export function careStatusColor(status) {
  return ['blue-6', 'green-6', 'red-6', 'grey-5', 'orange-6', 'red-6'][Number(status)] || 'grey-5';
}
